module.exports = __webpack_public_path__ + "static/pharmacy-806135b709d1d7653b2db4be74a4d5df.jpg";